<template>
  <v-stepper-content :step="step">
    <v-list>
      <v-list-item-group
        v-model="selectedIds"
        color="success"
        :multiple="multiple"
        :mandatory="mandatory"
        :max="category.max"
      >
        <v-list-item
          v-for="modifier in category.modifiers"
          :key="modifier.id"
          :value="modifier.id"
        >
          <v-list-item-content>
            <v-list-item-title v-text="modifier.name" />
          </v-list-item-content>
          <v-list-item-action-text>
            {{ modifier.price | currency | hideZero }}
          </v-list-item-action-text>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-stepper-content>
</template>

<script>
  import Currenciable from '@/Mixins/Currenciable'
  import Lockable from '@/Mixins/Lockable'

  export default {
    mixins: [
      Currenciable,
      Lockable,
    ],

    props: {
      index: {
        required: true,
        type: Number,
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    computed: {
      step () {
        return this.index + 1
      },
      category () {
        return this.$store.state.orders.modifiers.categories[this.index]
      },
      optional () {
        return this.category.min === 0
      },
      multiple () {
        return this.category.max > 1
      },
      editing () {
        return this.$store.state.orders.modifiers.editing
      },
      mandatory () {
        return this.editing && ! this.optional
      },
      isNotLastStep () {
        return this.$store.getters['orders/modifiers/isNotLastStep'](this.step)
      },
      selectedIds: {
        get () {
          return this.multiple
            ? this.category.modifiers.filter(o => o.selected).pluck('id')
            : this.category.modifiers.find(o => o.selected)?.id
        },
        set (v) {
          if (this.disabled || this.locked) {
            return
          }
          this.lock()
          this.$emit('change')
          const isValid = this.optional
            ? true
            : this.multiple
              ? Boolean(v.length)
              : v !== null && v !== undefined
          this.commit('select', v)
          this.commit('complete', isValid)
          this.commit('fail', ! isValid)
          if (! isValid || this.multiple || this.editing) {
            return
          }
          if (this.isNotLastStep) {
            this.$store.commit('orders/modifiers/nextStep')
            return
          }
          this.$store.dispatch('orders/modifiers/validate')
            .then(success => {
              if (success) {
                this.$emit('complete')
              }
            })
        }
      },
    },

    methods: {
      commit (action, value) {
        this.$store.commit(`orders/modifiers/${action}`, {
          index: this.category.index,
          value,
        })
      },
    },
  }
</script>
